import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import logo from '../../../images/inflo_logo.png';
import MobileFooter from '../../../components/widgets/MobileFooter';
import LoginInfloPage from './login/LoginInfloPage';

const INITIAL_STATE = {
  component: 'infloWelcome'
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class InfloWelcome extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  redirectToLoginInflo = () => {
    this.setState({ component: 'loginInflo' });
  };

  render() {
    if (
      this.state.component &&
      this.state.component !== 'loginInflo' &&
      this.state.component !== 'dashboard'
    ) {
      return (
        <React.Fragment>
          <Helmet>
            <style>{'body { background-color: white!important; }'}</style>
          </Helmet>
          {/*<MobileView viewClassName='mv'>
                    <Dialog ref={(el) => { this.dialog = el }} />
                    <Logo />
                    <div className="login-inflo-page">
                        <div className='loginInfloForm'>
                        <div className='logoInflo'><img src={logo} alt="logo"/></div>
                            <div className='textLogoInflo' style={{fontWeight:'400', fontSize:'15pt'}}>Goodbye Flagcast, Hello Inflo!</div>
                            <div style={{fontWeight:'300', fontSize:'12pt'}}>
                                <p>
                                    Hey there podcast fan, we wanted to let you know we are changing our app name from Flagcast to Inflo.
                                    iOS users will see an update notification in the next week or so, just click on it and you’re all set.
                                </p>
                                <p>
                                    To our attractive and charming Android users, Inflo is on the way, but it’s going to be just a bit longer 👿.
                                    We’re burning the midnight oil to get it done, but in the meantime please send your hate mail to kyle@ex-iq.com , he’s our intern 😊
                                </p>
                                <p>
                                    The Inflo rebrand is just the start; we’ll be announcing some really cool features at CES in January, so stay tuned!
                                </p>
                            </div>

                            <div style={{textAlign:'center'}}>
                                <button onClick={this.redirectToLoginInflo.bind(this)} className='btn login-inflo-button'>
                                    Sign in
                                </button>
                            </div>

                            <div className='row'>
                                <div id='linksInflo'>
                                    <span style={{color:'#a1a1a1'}}>© Copyright 2022 Inflo, Inc.</span>  |  <a className='linkpaInflo' href="https://www.notecast.app/privacy/">Privacy Policy</a>  |  <a className='linkpaInflo' href="https://www.notecast.app/legal/">License Agreement</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MobileFooter />
                </MobileView>
                <BrowserView>*/}
          <div>
            <div className="paddingBlockInflo login-inflo-page">
              <Row
                className="show-grid"
                style={{ marginRight: '0', marginLeft: '0' }}
              >
                <Col xs={5} className="loginInfloForm">
                  <div className="logoInflo">
                    <img src={logo} alt="logo" />
                  </div>
                  <div
                    className="textLogoInflo"
                    style={{
                      fontWeight: '400',
                      fontSize: '15pt',
                      marginBottom: '15px'
                    }}
                  >
                    Goodbye Flagcast, Hello Inflo!
                  </div>
                  <div style={{ fontWeight: '300', fontSize: '12pt' }}>
                    <p>
                      Hey there podcast fan, we wanted to let you know we are
                      changing our app name from Flagcast to Inflo.   iOS users
                      will see an update notification in the next week or so,
                      just click on it and you’re all set.
                    </p>
                    <p>
                      To our attractive and charming Android users, Inflo is on
                      the way, but it’s going to be just a bit longer 👿. We’re
                      burning the midnight oil to get it done, but in the
                      meantime please send your hate mail to kyle@ex-iq.com ,
                      he’s our intern 😊
                    </p>
                    <p>
                      The Inflo rebrand is just the start; we’ll be announcing
                      some really cool features at CES in January, so stay
                      tuned!
                    </p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <button
                      onClick={this.redirectToLoginInflo.bind(this)}
                      className="btn login-inflo-button"
                    >
                      Sign in
                    </button>
                  </div>
                  <MobileFooter />
                </Col>
              </Row>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return <LoginInfloPage />;
    }
  }
}

export default InfloWelcome;
